module.exports = __webpack_public_path__ + "static/media/policyIcon.c21f36c3.svg";